import("../src/javascripts/attachments-redesign");
import("../src/javascripts/navigation");
import("../src/javascripts/smooth-scroll-to-anchor");
